// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-menu-box {
  opacity: 1;
  border-radius: 19px;
  position: relative;
  z-index: -1;
}
.popup-menu-triangle-down {
  float: left;
  margin-left: 59px;
  font-size: 16px;
  text-shadow: 0px 8px 8px rgba(0, 0, 0, 0.16);
  z-index: 0;
}
.popup-menu-triangle-up {
  transform: rotate(180deg);
  position: absolute;
  bottom: 172px;
  margin-left: 60px;
  font-size: 16px;
  text-shadow: 0px 8px 8px rgba(0, 0, 0, 0.16);
  z-index: 0;
}
.delete-highlighter-container {
  position: relative;
}

.popup-close {
  position: absolute;
  top: -30px;
  right: 70px;
  cursor: pointer;
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupMenu/popupMenu.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,4CAA4C;EAC5C,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB","sourcesContent":[".popup-menu-box {\n  opacity: 1;\n  border-radius: 19px;\n  position: relative;\n  z-index: -1;\n}\n.popup-menu-triangle-down {\n  float: left;\n  margin-left: 59px;\n  font-size: 16px;\n  text-shadow: 0px 8px 8px rgba(0, 0, 0, 0.16);\n  z-index: 0;\n}\n.popup-menu-triangle-up {\n  transform: rotate(180deg);\n  position: absolute;\n  bottom: 172px;\n  margin-left: 60px;\n  font-size: 16px;\n  text-shadow: 0px 8px 8px rgba(0, 0, 0, 0.16);\n  z-index: 0;\n}\n.delete-highlighter-container {\n  position: relative;\n}\n\n.popup-close {\n  position: absolute;\n  top: -30px;\n  right: 70px;\n  cursor: pointer;\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
